import { render, staticRenderFns } from "./AverageTripType.vue?vue&type=template&id=9ffeefa4&scoped=true&"
import script from "./AverageTripType.vue?vue&type=script&lang=js&"
export * from "./AverageTripType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffeefa4",
  null
  
)

export default component.exports